import React, { useEffect, useRef, useState } from 'react'
import { Bell, ChevronRight, Import, ArrowLeft } from 'assets'
import CustomButton from 'components/CustomButton'
import { Container } from 'reactstrap'
import InfoLagu from './InfoLagu'
import DetailLagu from './DetailLagu'
import HargaLagu from './HargaLagu'
import { API_GET_MAMBOO, API_POST_MAMBOO } from 'services'
import { Alert, AlertNotif } from 'components/Alert'
import { getCookie } from 'services/cookies'
import useLoginStore from 'hooks/useLoginStore'

const AddLagu = ({ data, handleOnClick }) => {
  const { profile } = useLoginStore()

  // Kode `01` di rt_creator berarti Publisher. Baris pertama Perjanjian Lisensi
  // selalu baris publisher, dan `creator_id`-nya wajib sama dengan
  // `song.publisher_id`: query katalog memisahkan baris publisher dari baris
  // pencipta lewat pasangan itu (`ld.creator_code = '01' and ld.creator_id =
  // s.publisher_id`). Jadi baris ini tidak boleh berisi id pencipta.
  const CREATOR_CODE_PUBLISHER = "01"
  const ROLE_PENCIPTA = 3
  const isPencipta = Number(profile.role_code) === ROLE_PENCIPTA

  // Harga lagu adalah kewenangan publisher. Pencipta hanya mengajukan lagunya,
  // jadi tab Harga (Opsi Pemakaian Lagu & Kustomisasi Harga) tidak ditampilkan
  // untuknya. Payload harganya tetap dikirim dengan nilai 0 — lihat
  // payloadHarga di handleClickSimpan — supaya tiap opsi sudah punya
  // `price_id` sejak awal dan publisher bisa mengisinya lewat Edit Lagu.
  const listMenu = [
    { no: 1, name: 'Info Lagu' },
    { no: 2, name: 'Detail' },
    ...(isPencipta ? [] : [{ no: 3, name: 'Harga' }]),
  ]
  const [menuActive, setMenuActive] = useState(listMenu[0])

  // Langkah terakhir menentukan label tombol dan kapan lagu benar-benar
  // disimpan. Dulu dipatok ke nama tab 'Harga'; kini tab itu tidak selalu ada.
  const isLastStep = menuActive.no === listMenu.length
  const [creator, setCreator] = useState([])
  const [genre, setGenre] = useState([])
  const [era, setEra] = useState([])
  const [projectType, setProjectType] = useState([])
  const [role, setRole] = useState([])
  const [pencipta, setPencipta] = useState([])
  const profileUser = getCookie('profile')
  const ipBaseNumber = getCookie('ip_base_number')

  //info lagu state
  const [isErrorPembagian, setIsErrorPembagian] = useState([])

  // Format nama mengikuti daftar anggota dari backend: "<ip base atau mamboo id> - <nama>".
  const selfLabel = `${profile.ip_base_number ? profile.ip_base_number : profile.mamboo_id} - ${profile.name}`

  // Publisher yang menaungi lagu. Untuk publisher yang login, itu dirinya
  // sendiri; untuk admin, `publisher_data`; untuk pencipta, `referal` — dan
  // namanya baru diketahui setelah daftar anggota tiba, jadi dilengkapi di
  // useEffect di bawah.
  const publisherLabel = profile.publisher_data
    ? `${profile.publisher_data.combination}`
    : isPencipta ? "" : selfLabel

  const [penciptaHeader, setPenciptaHeader] = useState({
    namaPencipta: publisherLabel,
    creator_id: isPencipta ? profile.referal || "" : "",
    sebagai: CREATOR_CODE_PUBLISHER,
    mech: 0,
    perform: 0,
    sync: 0,
    demd: 0,
    isErrorNama: false,
  })

  const [penciptaHeaderObject, setPenciptaHeaderObject] = useState({})

  const [dataPencipta, setDataPencipta] = useState([])
  const [judulLain, setJudulLain] = useState([])
  // Disimpan di sini (bukan di InfoLagu) supaya tidak hilang saat berpindah tab.
  // Dikirim sebagai `asset` di payload registerSong -> tabel publisher.song_asset.
  const [asetId, setAsetId] = useState([])
  const [dspOptions, setDspOptions] = useState([])

  // Persetujuan pengelolaan karya. Wajib dicentang pencipta sebelum pengajuan
  // dikirim — publisher yang mendaftarkan langsung ke katalog tidak melaluinya,
  // karena pernyataan ini atas nama pemilik karya.
  const [isAgreed, setIsAgreed] = useState(false)
  const [isAgreeError, setIsAgreeError] = useState(false)
  const agreementRef = useRef(null)
  const [informasiLagu, setInformasiLagu] = useState({
    judul_lagu: "",
    iswc_number: "",
    judul_lain: [],
    link_youtube: "",
    work_id: ""
  })

  const [dataPenyanyi, setDataPenyanyi] = useState([
    {
      nama_penyanyi: '',
      isrc_number: ''
    }
  ])
  // ======== end

  // detail lagu state and function

  const [dataDetailLagu, setDataDetailLagu] = useState({
    genre: "",
    era: ""
  })

  const onChangeSelect = (val) => {
    // console.log(val)
    setDataDetailLagu((prev) => ({ ...prev, [val.name]: val }))
  }

  // ======= end

  // harga lagu state and function
  const [usage, setUsage] = useState({
    is_exclusive: false,
    is_monthly: false
  })

  const [price, setPrice] = useState([])

  function handleInitState() {
    const initData = projectType.map((val) => {
      return {
        project_type: val.category_code,
        price: '',
        is_checked: false,
        sub_detail: val.project_type.map((project) => {
          return {
            project_type: project.project_code,
            price: "",
            is_checked: false,
            sub_detail: project.sub_detail ? project.sub_detail.map((data) => {
              return {
                project_type_parent: data.project_type,
                is_checked: false,
                project_type: data.ads_code,
                price: ""
              }
            }) : null
          }
        })
      }
    })
    // console.log(initData)

    setPrice(initData)
  }

  const onCheckUsage = (e) => {
    const { name, value, checked } = e.target
    setUsage((prev) => ({ ...prev, [name]: checked }))
  }

  const onCheckHarga = (e, index, child, deepIndex) => {
    const { name, checked } = e.target
    const currentData = [...price]

    if (deepIndex || deepIndex >= 0) {
      currentData[index].sub_detail[child].sub_detail[deepIndex].is_checked = checked
      return setPrice(currentData)
    }

    if (child || child >= 0) {
      currentData[index].sub_detail[child].is_checked = checked
      return setPrice(currentData)
    }


    currentData[index].is_checked = checked
    setPrice(currentData)
  }

  const onChangePrice = (e, index, child, deepIndex) => {
    const { name, value } = e.target
    const regex = /[0-9]|\./
    if (!regex.test(value[value.length - 1]) && value) return
    const currentData = [...price]

    if (deepIndex || deepIndex >= 0) {
      currentData[index].sub_detail[child].sub_detail[deepIndex].price = value.replaceAll('.', '')
      currentData[index].sub_detail[child].sub_detail[deepIndex].is_checked = value ? true : false
      return setPrice(currentData)
    }

    if (child || child >= 0) {
      currentData[index].sub_detail[child].price = value.replaceAll('.', '')
      currentData[index].sub_detail[child].is_checked = value ? true : false
      return setPrice(currentData)
    }

    currentData[index].price = value.replaceAll('.', '')
    setPrice(currentData)
  }

  // ======= end

  const handleClickMenu = (menu) => {
    setMenuActive((prev) => {
      if (prev.no < menu.no) return prev
      return menu
    })
  }

  const refFormatter = (data, name) => {
    if (name === 'pencipta') {
      // `email` dan `role_code` dipakai untuk mencocokkan diri sendiri dan
      // publisher tanpa bergantung pada string nama yang sudah diberi awalan.
      return data.map((val) => ({
        label: val.name,
        value: val.name,
        id: val.creator_id,
        email: val.email,
        role_code: val.role_code,
      }))
    }
    return data.map((val) => ({ label: val[name], value: val[`${name}_code`], name }))
  }

  const getCreator = async () => {
    await API_GET_MAMBOO.dynamic.getCreator()
      .then((response) => setCreator(refFormatter(response, 'creator')))
      .catch((err) => console.log(err))
  }

  const getEra = async () => {
    await API_GET_MAMBOO.dynamic.getEra()
      .then((response) => setEra(refFormatter(response, 'era')))
      .catch((err) => console.log(err))
  }

  const getGenre = async () => {
    await API_GET_MAMBOO.dynamic.getGenre()
      .then((response) => setGenre(refFormatter(response, 'genre')))
      .catch((err) => console.log(err))
  }

  const getRole = async () => {
    await API_GET_MAMBOO.dynamic.getRole()
      .then((response) => setRole(refFormatter(response, 'role')))
      .catch((err) => console.log(err))
  }

  const getDsp = async () => {
    await API_GET_MAMBOO.dynamic.getDsp()
      .then((response) => setDspOptions(response.map((x) => ({ label: x.dsp, value: x.dsp_code }))))
      .catch((err) => console.log(err))
  }

  const getPencipta = async (keyword = '') => {
    await API_GET_MAMBOO.dynamic.getByRole('3', keyword, false, '')
      .then((response) => {
        const options = refFormatter(response, 'pencipta')

        // Backend mengembalikan seluruh anggota di bawah publisher yang sama.
        // Untuk publisher/admin itu memang dibutuhkan: mereka mendaftarkan lagu
        // atas nama siapa pun di katalognya. Tapi pencipta yang mengajukan
        // lagunya sendiri hanya berhak menamai dirinya dan publisher yang
        // menaunginya — nama rekan pencipta lain tidak perlu, dan menampilkannya
        // membocorkan daftar anggota ke sesama anggota.
        //
        // Kedua opsi ini juga yang dipakai useEffect di bawah untuk mengisi
        // baris awal, jadi penyaringan di sini tidak boleh membuang salah satunya.
        setPencipta(
          isPencipta
            ? options.filter(
              (x) => x.id === profile.referal || x.email === profile.email
            )
            : options
        )
      })
      .catch((err) => console.log(err))
  }

  const getProjectType = async () => {
    await API_GET_MAMBOO.dynamic.getProjectType()
      .then((response) => {
        response.forEach((data) => {
          data.project_type.forEach((val) => {
            if (val.sub_detail.length === 0) {
              val.sub_detail = null
            }
          })
        })
        setProjectType(response)
      })
      .catch((err) => console.log(err))
  }

  const errorChecker = (data) => {
    const objectData = {
      sync: 0,
      demd: 0,
      perform: 0,
      mech: 0
    }

    const {
      mech,
      perform,
      demd,
      sync
    } = objectData

    data.forEach((val) => {
      for (let key in val) {
        if (key !== 'sebagai' && key !== 'namaPencipta') {
          objectData[key] += Number(val[key])
        }
      }
    })


    const isValidMech = mech == 100
    const isValidPerform = perform == 100
    const isValidDemd = demd == 100
    const isValidSync = sync == 100

    if (isValidDemd || isValidMech || isValidPerform || isValidSync) {
      setIsErrorPembagian(true)
      return true
    }
    setIsErrorPembagian(false)
    return false
  }

  const registerSong = async (data, dataHarga) => {
    await API_POST_MAMBOO.actions.saveLagu(data)
      .then((response) => {
        dataHarga.song_id = response.song_id
        return API_POST_MAMBOO.actions.saveHargaLagu(dataHarga)
      })
      .then((response) => handleOnClick(''))
      .catch((err) => console.log(err))
  }

  const handleClickSimpan = async () => {
    setIsErrorPembagian([])
    if (menuActive.name === 'Info Lagu') {
      const dataToCheck = [...dataPencipta, penciptaHeader]
      let mech = 0
      let sync = 0
      let demd = 0
      let perform = 0
      dataToCheck.forEach((data) => {
        mech += Number(data.mech)
        sync += Number(data.sync)
        demd += Number(data.demd)
        perform += Number(data.perform)
      })
      let isPembagianError = false
      if (perform !== 100 && perform > 0) {
        isPembagianError = true
        setIsErrorPembagian((prev) => [...prev, { name: 'Perform', isError: true }])
      }
      if (demd !== 100 && demd > 0) {
        isPembagianError = true
        setIsErrorPembagian((prev) => [...prev, { name: 'Demd', isError: true }])
      }
      if (sync !== 100 && sync > 0) {
        isPembagianError = true
        setIsErrorPembagian((prev) => [...prev, { name: 'Synchronize', isError: true }])
      }
      if (mech !== 100 && mech > 0) {
        isPembagianError = true
        setIsErrorPembagian((prev) => [...prev, { name: 'Mech', isError: true }])
      }

      let isNamaError = false

      dataToCheck.some((data) => {
        if(!data.namaPencipta || !data.sebagai) {
          isNamaError = true
          return
        }
      })

      const errorName = []
      if(isNamaError) {
        errorName.push('Nama')
        errorName.push('Sebagai')
      }

      if(isPembagianError) {
        errorName.push('Pembagian Hak')
      }

      if (isPembagianError || isNamaError) {
        return AlertNotif({
          icon: 'warning',
          title: 'Data belum lengkap',
          html: `<p>Pastikan kolom ${errorName.map((x, index) => (`<b>${index === errorName.length - 1 && errorName.length > 1 ? ' dan ' : '' } ${x}${index !== errorName.length - 1 && errorName.length > 2 ? '' : ''}</b>`))} sudah terisi dengan benar.</p>`
        })
      }
      return setMenuActive((prev) => listMenu[prev.no])
    } else if (!isLastStep) {
      return setMenuActive((prev) => listMenu[prev.no])
    } else {
      // Pengajuan tidak boleh berangkat tanpa pernyataan. Diperiksa sebelum
      // apa pun dibangun, dan kartunya digulirkan ke layar — tombol Simpan ada
      // di bagian atas halaman, jadi tanpa ini pengguna tidak tahu apa yang
      // kurang.
      if (isPencipta && !isAgreed) {
        setIsAgreeError(true)
        agreementRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        return AlertNotif({
          icon: 'warning',
          title: 'Pernyataan belum disetujui',
          html: '<p>Centang <b>Persetujuan Pengelolaan Karya</b> terlebih dahulu sebelum mengirim pengajuan.</p>'
        })
      }

      const headerPencipta = { ...penciptaHeader }

      // Dulu baris ini `pencipta.filter(...)[0].id` — melempar TypeError begitu
      // namanya tidak ada di daftar anggota. Sekarang id-nya sudah disiapkan di
      // useEffect, dan pencocokan nama hanya jadi cadangan.
      const headerOption = pencipta.find((x) => x.label === penciptaHeader.namaPencipta)
      headerPencipta.creator_id = headerPencipta.creator_id || (headerOption ? headerOption.id : '')

      // Tidak boleh dilanjutkan dengan nama sebagai creator_id: backend
      // menganggap creator_id non-UUID sebagai tamu undangan dan membuat user
      // baru untuk nilai itu (service.ts → guest). Lebih baik berhenti di sini.
      if (!headerPencipta.creator_id) {
        return AlertNotif({
          icon: 'warning',
          title: 'Data publisher belum lengkap',
          html: '<p>Baris <b>publisher</b> pada Perjanjian Lisensi belum terisi. Muat ulang halaman, lalu coba simpan kembali.</p>'
        })
      }
      const dataToSave = [...dataPencipta, headerPencipta]
      // console.log(dataToSave)
      const isError = errorChecker(dataToSave)
      const payload = {
        song_title: informasiLagu.judul_lagu,
        creator_id: dataToSave.map((data) => data.creator_id || data.namaPencipta),
        another_song_title: judulLain,
        iswc_number: informasiLagu.iswc_number,
        youtube_link: informasiLagu.link_youtube,
        lisence: dataToSave.map((data) => ({
          creator_id: data.creator_id || data.namaPencipta,
          creator_code: data.sebagai,
          creator_name: data.namaPencipta,
          mech: Number(data.mech),
          sync: Number(data.sync),
          demd: Number(data.demd),
          perform: Number(data.perform)
        })),
        singer: dataPenyanyi.map((data) => ({
          singer: data.nama_penyanyi,
          isrc_number: data.isrc_number
        })),
        era: dataDetailLagu.era.value,
        genre_code: dataDetailLagu.genre.value,
        // Asset ID per DSP -> publisher.song_asset. Baris tanpa asset_id
        // disaring backend (toAssetRows), kolomnya NOT NULL.
        asset: asetId.map((row) => ({
          asset_id: row.asset_id,
          dsp_code: row.dsp_code || null,
        }))
      }

      // Seluruh baris harga dikirim — termasuk opsi yang tidak dicentang, dengan
      // harga 0. Jadi bagian "Opsi Pemakaian Lagu" dan "Kustomisasi Harga"
      // tidak lagi wajib diisi untuk mendaftarkan lagu.
      //
      // Alasan mengirim yang kosong sekalipun: backend membuat baris price
      // lewat `bulkCreate`, dan tiap baris memperoleh `price_id` sendiri yang
      // terikat ke `song_id` (services/service.ts → insertPrice). Saat lagu
      // disunting, backend memakai `if (x.price_id) update else create`, jadi
      // baris yang sudah ada akan di-update. Dengan menyiapkan semua project
      // type sejak pendaftaran, tiap opsi punya price_id tetap sejak awal dan
      // strukturnya utuh.
      //
      // `flatMap` menggantikan `filter(...)[0].sub_detail` yang lama: pola itu
      // hanya mengambil sub_detail dari project pertama yang punya anak, dan
      // melempar TypeError bila tidak ada satu pun yang punya.
      const projectRows = price.flatMap((category) => category.sub_detail || [])
      const adsRows = projectRows.flatMap((project) => project.sub_detail || [])

      // Harga hanya melekat pada simpul terdalam. Project yang punya anak
      // (mis. Iklan) tidak membawa harga sendiri — anaknya yang membawa.
      const leafProjectRows = projectRows.filter(
        (project) => !project.sub_detail || project.sub_detail.length === 0
      )

      // Hanya kolom yang benar-benar ada di tabel price. `is_checked` dan
      // `sub_detail` tidak punya kolom di sana, jadi tidak perlu ikut dikirim.
      const toPriceRow = (row) => ({
        project_type: row.project_type,
        price: Number(row.price) || 0,
        ...(row.project_type_parent && {
          project_type_parent: row.project_type_parent,
        }),
      })

      const payloadHarga = {
        usage_option: usage,
        price: [...adsRows, ...leafProjectRows].map(toPriceRow)
      }

      // console.log({ payload, payloadHarga })

      Alert({
        icon: 'warning',
        title: 'Tambah Lagu',
        text: `Pastikan data yang terisi sudah benar`,
        showCancelButton: true,
        showConfirmButton: true,
        showLoaderOnConfirm: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Batal',
        confirmButtonColor: 'var(--danger)',
        successText: `Lagu '${informasiLagu.judul_lagu}' berhasil ditambahkan`,
        failText: `Lagu '${informasiLagu.judul_lagu} gagal ditambahkan`,
        cancelText: `Lagu '${informasiLagu.judul_lagu}' batal ditambahkan`,
        confirmed: () => registerSong(payload, payloadHarga)
      })
    }

  }

  useEffect(() => {
    if (projectType.length > 0) {
      handleInitState()
    }
  }, [projectType])

  // Baris awal Perjanjian Lisensi baru bisa dilengkapi setelah daftar anggota
  // tiba: id publisher maupun id pencipta yang login hanya ada di daftar itu
  // (respons login sengaja tidak mengembalikan user_id sendiri).
  useEffect(() => {
    if (pencipta.length === 0) return

    const publisherOption = isPencipta
      ? pencipta.find((x) => x.id === profile.referal)
      : pencipta.find((x) => x.label === publisherLabel)

    if (publisherOption) {
      setPenciptaHeader((prev) => ({
        ...prev,
        namaPencipta: publisherOption.label,
        creator_id: publisherOption.id,
      }))
      setPenciptaHeaderObject(publisherOption)
    }

    // Pencipta yang mengajukan lagunya otomatis mengisi baris pertama di bawah
    // publisher. Perannya (Komposer/Penulis Lirik/…) dan pembagian haknya tetap
    // ia pilih sendiri — yang didefaultkan hanya namanya. Dicocokkan lewat
    // email, bukan nama, karena nama di daftar sudah diawali IP base/Mamboo ID.
    if (isPencipta) {
      const selfOption = pencipta.find((x) => x.email === profile.email)
      if (selfOption) {
        setDataPencipta((prev) => (prev.length > 0 ? prev : [{
          creator_id: selfOption.id,
          namaPencipta: selfOption.label,
          sebagai: "",
          mech: 0,
          perform: 0,
          sync: 0,
          demd: 0,
        }]))
      }
    }
  }, [pencipta])

  useEffect(() => {
    getRole()
    getProjectType()
    getGenre()
    getEra()
    getCreator()
    getPencipta()
    getDsp()
  }, [])

  return (
    <Container fluid className='katalog-lagu-container'>
      <div>
        <div className='header-content'>
          <div className='katalog-header'>
            <h1>Pendaftaran Katalog Lagu</h1>
            <span>Pendaftaran lagu baru ke dalam publisher-mu</span>
            {/* <div className='container-kembali' onClick={() => handleOnClick('')}>
          <ArrowLeft style={{ stroke: 'var(--text-strong)' }} />
          <span className='text-kembali'>Batal</span>
        </div> */}
          </div>
          <div className='icon-wrapper'>
            <Bell />
          </div>
        </div>
        <div className='bread-crumbs-wrapper'>
          <div className='bread-crumbs-katalog'>
            {listMenu.map((menu, index) => (
              <React.Fragment key={menu.no}>
                <div
                  onClick={() => handleClickMenu(menu)}
                  className={`bread-crumbs-item ${menuActive.name === menu.name ? 'active' : ''}`}
                >
                  {menu.name}
                </div>
                {index !== (listMenu.length - 1) && (
                  <ChevronRight className={`bread-crumbs-svg ${menuActive.name === menu.name ? 'svg-active' : ''}`} />
                )}
              </React.Fragment>
            ))}
          </div>
          <div className='bread-crumbs-actions'>
            <CustomButton
              label="Import"
              LabelIcon={Import}
              iconPosition="left"
              size="md"
              className="button-import"
            />
            <CustomButton
              label={!isLastStep ? 'Simpan dan Lanjutkan' : 'Simpan'}
              color="primary-btn"
              className="btn-simpan"
              onClick={handleClickSimpan}
            />
          </div>
        </div>
      </div>
      {menuActive.name === 'Info Lagu' && <InfoLagu
        penciptaHeader={penciptaHeader}
        dataPencipta={dataPencipta}
        dataPenyanyi={dataPenyanyi}
        judulLain={judulLain}
        informasiLagu={informasiLagu}
        setPenciptaHeader={setPenciptaHeader}
        setDataPencipta={setDataPencipta}
        setDataPenyanyi={setDataPenyanyi}
        setJudulLain={setJudulLain}
        setInformasiLagu={setInformasiLagu}
        isErrorPembagian={isErrorPembagian}
        creator={creator}
        pencipta={pencipta}
        setPencipta={setPencipta}
        penciptaHeaderObject={penciptaHeaderObject}
        setPenciptaHeaderObject={setPenciptaHeaderObject}
        asetId={asetId}
        setAsetId={setAsetId}
        dspOptions={dspOptions}
        isNamaLocked={isPencipta}
        isSongwriter={isPencipta}
      />}
      {menuActive.name === 'Detail' && <DetailLagu onChangeSelect={onChangeSelect} genre={genre} era={era} dataDetailLagu={dataDetailLagu} />}

      {/* Hanya di langkah terakhir: pernyataan dibaca tepat sebelum dikirim,
          bukan di awal formulir yang masih bisa berubah isinya. */}
      {isPencipta && isLastStep && (
        <section
          ref={agreementRef}
          className={`form-wrapper lagu-card lagu-agreement ${isAgreeError ? 'is-error' : ''}`}
        >
          <div className='lagu-card-header'>
            <h3>Persetujuan Pengelolaan Karya</h3>
          </div>
          <label className='lagu-agreement-check' htmlFor='persetujuan-pengelolaan'>
            <input
              id='persetujuan-pengelolaan'
              type='checkbox'
              checked={isAgreed}
              onChange={(e) => {
                setIsAgreed(e.target.checked)
                if (e.target.checked) setIsAgreeError(false)
              }}
            />
            <span>
              Saya menyatakan bahwa saya memiliki hak atau kewenangan yang sah atas
              karya yang saya unggah dan menyetujui agar karya tersebut dikelola oleh
              LOKA Publishing (PT Kelola Karya Indonesia) sesuai dengan ketentuan dalam
              Kontrak Pencipta yang telah saya setujui. Saya memahami bahwa pengunggahan
              dan persetujuan ini menjadi dasar untuk memperbarui serta menambahkan karya
              tersebut ke dalam katalog pengelolaan LOKA Publishing, dan karya tersebut
              termasuk dalam cakupan pengelolaan berdasarkan Kontrak Pencipta tersebut.
            </span>
          </label>
          {isAgreeError && (
            <p className='lagu-agreement-error' role='alert'>
              Pernyataan ini wajib disetujui sebelum pengajuan dikirim.
            </p>
          )}
        </section>
      )}
      {!isPencipta && menuActive.name === 'Harga' && <HargaLagu onChangePrice={onChangePrice} onCheckHarga={onCheckHarga} onCheckUsage={onCheckUsage} usage={usage} price={price} page="create" projectType={projectType} />}
    </Container >
  )
}

export default AddLagu